// extracted by mini-css-extract-plugin
module.exports = {"card":"UserDesignCard_card__g4KeD","imageContainer":"UserDesignCard_imageContainer__Qp1KE","workName":"UserDesignCard_workName__kHj73"};